export const sendEmail = (e:Event) => {
	const target = e.target as HTMLElement;
	const btnEl = target.closest('button') as HTMLButtonElement;
	window.open(`https://${btnEl.dataset.dsetDomain}`)
}
